"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var editInboxRule_1 = require("../actions/editInboxRule");
var enableDisableInboxRule_1 = require("../actions/enableDisableInboxRule");
var removeInboxRule_1 = require("../actions/removeInboxRule");
var store_1 = require("../store/store");
var index_1 = require("@uifabric/styling/lib/index");
var mobx_react_1 = require("mobx-react");
var Toggle_1 = require("office-ui-fabric-react/lib/components/Toggle");
var DragAndDroppable_1 = require("owa-dnd/lib/components/DragAndDroppable");
var DraggableItemTypes_1 = require("owa-dnd/lib/utils/DraggableItemTypes");
var owa_inbox_rules_option_1 = require("owa-inbox-rules-option");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styles = require('./InboxRuleRow.scss');
var classNames = require('classnames/bind').bind(styles);
var InboxRuleRow = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRuleRow, _super);
    function InboxRuleRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Helper method that handles user click on toggle
         * @param event user click event
         * @param shouldBeEnabled whether rule should be enabled
         */
        _this.onEnableDisableInboxRule = function (event, shouldBeEnabled) {
            event.stopPropagation();
            enableDisableInboxRule_1.default(_this.props.inboxRuleId, shouldBeEnabled);
        };
        /**
         * Helper method that handles user click on delete
         * @param event user click event
         */
        _this.onRemoveInboxRule = function (event) {
            event.stopPropagation();
            removeInboxRule_1.default(_this.props.inboxRuleId);
        };
        /**
         * Helper method that handles user click on edit
         * @param event user click event
         */
        _this.onEditInboxRule = function (event) {
            event.stopPropagation();
            editInboxRule_1.default(_this.props.inboxRuleId);
        };
        _this.getDragData = function () {
            var inboxRuleId = _this.props.inboxRuleId;
            var ruleRowDragData = {
                itemType: DraggableItemTypes_1.DraggableItemTypes.InboxRule,
                ruleId: inboxRuleId,
                ruleName: store_1.default.inboxRulesListState.inboxRules.get(inboxRuleId).Name,
            };
            return ruleRowDragData;
        };
        _this.getDragPreview = function (ruleDragData) {
            var elem = document.createElement('div');
            elem.className = styles.dragHelperStyle;
            elem.innerText = ruleDragData.ruleName;
            return elem;
        };
        _this.canDrop = function (dragData) {
            return dragData.itemType === DraggableItemTypes_1.DraggableItemTypes.InboxRule;
        };
        _this.onDrop = function (dragData) {
            var draggedRule = dragData;
            var draggedRuleId = draggedRule.ruleId;
            var dragTargetRuleId = _this.props.inboxRuleId;
            // Moves rule to new position
            owa_inbox_rules_option_1.lazyMoveInboxRule.importAndExecute(draggedRuleId /* idToUpdate */, dragTargetRuleId /* destinationRuleId */);
        };
        return _this;
    }
    InboxRuleRow.prototype.shouldShowEditButton = function (inboxRuleRow) {
        // Do not show edit button if the rule is not supported by OWA OR
        // rule has a clause type we don't support just yet
        // VSTS: 23316 and 23317 Add remaining conditions, actions, and exceptions
        // Check that the rule user wants to edit does not have any clauses that have
        // not been implemented yet.
        return (inboxRuleRow.SupportedByTask &&
            !inboxRuleRow.ApplyCategory &&
            !inboxRuleRow.ApplySystemCategory &&
            !inboxRuleRow.HasClassification &&
            !inboxRuleRow.ExceptIfHasClassification &&
            !inboxRuleRow.FromSubscription &&
            !inboxRuleRow.ExceptIfFromSubscription &&
            !inboxRuleRow.SendTextMessageNotificationTo);
    };
    InboxRuleRow.prototype.render = function () {
        var _this = this;
        var inboxRuleRow = store_1.default.inboxRulesListState.inboxRules.get(this.props.inboxRuleId);
        var descriptionText = this.getDescriptionText(inboxRuleRow.Description);
        var isRuleSupported = inboxRuleRow.SupportedByTask;
        var warningMessages = inboxRuleRow.WarningMessages;
        var shouldShowAlert = !(isRuleSupported && !warningMessages);
        var inboxRuleRowClassName = classNames(styles.inboxRuleContainer, inboxRuleRow.drop.isDragOver && styles.showBorderOnDroppedOver);
        return (React.createElement(DragAndDroppable_1.default, { getDragData: this.getDragData, getDragPreview: this.getDragPreview, dropViewState: inboxRuleRow.drop, onDrop: this.onDrop, canDrop: this.canDrop },
            React.createElement("div", { className: inboxRuleRowClassName, tabIndex: -1 },
                React.createElement("div", { className: styles.inboxRuleLeft },
                    React.createElement(Toggle_1.Toggle, { className: styles.inboxRuleToggle, styles: {
                            pillChecked: styles.themeDarkBackground,
                            pillHovered: styles.themeDarkerBackground,
                        }, checked: !shouldShowAlert ? inboxRuleRow.Enabled : false, disabled: shouldShowAlert, offAriaLabel: owa_options_strings_1.default.options_inboxRules_ruleDisabledAriaText, onAriaLabel: owa_options_strings_1.default.options_inboxRules_ruleEnabledAriaText, onClick: function (evt) {
                            _this.onEnableDisableInboxRule(evt, !inboxRuleRow.Enabled);
                        } }),
                    React.createElement("div", { className: styles.inboxRuleText },
                        React.createElement("div", { className: styles.inboxRuleName }, inboxRuleRow.Name),
                        React.createElement("div", { className: styles.inboxRuleHelperText }, descriptionText),
                        shouldShowAlert && (React.createElement("div", { className: styles.inboxRuleAlert },
                            React.createElement("div", { className: classNames(index_1.getIconClassName("Warning" /* Warning */), styles.icon) }),
                            React.createElement("span", null, this.getAlertString(isRuleSupported, warningMessages)))))),
                React.createElement("div", { className: styles.hoverIcons },
                    this.shouldShowEditButton(inboxRuleRow) && (React.createElement("div", { className: classNames(index_1.getIconClassName("Edit" /* Edit */), styles.icon), onClick: this.onEditInboxRule, "aria-label": 'Edit rule' })),
                    React.createElement("div", { className: classNames(index_1.getIconClassName("Delete" /* Delete */)), onClick: this.onRemoveInboxRule, "aria-label": owa_options_strings_1.default.options_inboxRules_deleteRuleAriaText })))));
    };
    /**
     * Gets the description text for the given inbox rule
     * @param inboxRuleDescriptions the inbox rule clause descriptions
     * @return inbox rule description
     */
    InboxRuleRow.prototype.getDescriptionText = function (inboxRuleDescriptions) {
        var andDelimeter = ' ' + owa_options_strings_1.default.options_inboxRules_and + ' ';
        var orDelimeter = ' ' + owa_options_strings_1.default.options_inboxRules_or + ' ';
        var commaDelimeter = ', ';
        var period = '.';
        // Create the description string from all the clauses
        // For example: If <conditional clause 1>, <conditional clause 2> and <conditional clause 3>,
        // <action clause 1>, <action clause 2> and <action clause 3>,
        // except when <exception clause 1>, <exception clause 2> or <exception clause 3>
        var descriptionText = owa_options_strings_1.default.options_inboxRules_if + ' ';
        descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ConditionDescriptions, commaDelimeter, andDelimeter);
        descriptionText += commaDelimeter;
        descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ActionDescriptions, commaDelimeter, andDelimeter);
        var exceptionDescriptions = inboxRuleDescriptions.ExceptionDescriptions;
        if (exceptionDescriptions.length > 0) {
            descriptionText += commaDelimeter + owa_options_strings_1.default.options_inboxRules_exceptWhen + ' ';
            descriptionText += this.getDescriptionTextHelper(inboxRuleDescriptions.ExceptionDescriptions, commaDelimeter, orDelimeter);
        }
        descriptionText += period;
        return descriptionText;
    };
    /**
     * Gets the description text for a clause for the given inbox rule (conditional, action, exception)
     * @param descriptions the descriptions for an inbox rule's clause
     * @param midDelimeter the delimeter for between clauses except between the second to last and last clauses
     * @param lastDelimeter the delimeter for between the second to last and last clauses
     * @return the concatenated, user-ready description for an inbox rule's clause
     */
    InboxRuleRow.prototype.getDescriptionTextHelper = function (descriptions, midDelimeter, lastDelimeter) {
        var descriptionText = '';
        for (var i = 0; i < descriptions.length; i++) {
            descriptionText += descriptions[i];
            // Clauses should be separated by ',' except for between the second to last and last clauses,
            // which should be separated by 'and'
            if (i < descriptions.length - 2) {
                descriptionText += midDelimeter;
            }
            else if (i === descriptions.length - 2) {
                descriptionText += lastDelimeter;
            }
        }
        return descriptionText;
    };
    /**
     * Helper method that gets alert strings for rules
     * @param isRuleSupported whether rule is supported in OWA
     * @param warningMessages warning messages if the rule is broken
     * @return Alert string
     */
    InboxRuleRow.prototype.getAlertString = function (isRuleSupported, warningMessages) {
        var alertString = '';
        var spaceDelimeter = ' ';
        if (!isRuleSupported) {
            // TODO: VSTS Localize 19216
            alertString += 'This rule does not work in OWA.' + spaceDelimeter;
        }
        if (warningMessages) {
            for (var _i = 0, warningMessages_1 = warningMessages; _i < warningMessages_1.length; _i++) {
                var warningMessage = warningMessages_1[_i];
                alertString += warningMessage + spaceDelimeter;
            }
        }
        return alertString;
    };
    InboxRuleRow = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRuleRow);
    return InboxRuleRow;
}(React.Component));
exports.default = InboxRuleRow;
//# sourceMappingURL=InboxRuleRow.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/InboxRuleRow.js
// module id = 5164
// module chunks = 2